import { useState, useEffect } from 'react';
import DashboardLayout from '../../../../layouts/DashboardLayout';
import ModalUsers from '../../components/ModalUsers/ModalUsers';
import ModalInvitacions from '../../components/ModalUsers/ModalInvitations';
import { TABS_USERS, TABS_USERS_ENUM, ROLE_LABEL } from '../../interfaces/users.interface';
import { DataTable } from '../../../../components/DataTable/DataTable';
import ActionsTable from '../../../../components/GenericComponents/ActionsTable';
import { usersApi } from '../../api/users.api';
import toast from 'react-hot-toast';
import { useUsers } from '../../hooks/useUsers';
import { useInvitations } from '../../hooks/useInvitations';
import { MODE } from '../../../../interaces/mode.interface';
import { FaTimesCircle, FaCheckCircle } from 'react-icons/fa';
import ConfirmationMessage from '../../../../components/GenericComponents/ConfirmationMessage';
import {
  TOAST_SUCCESS_IDS,
  TOAST_INFO_IDS,
  TOAST_ERROR_IDS,
} from '../../../../interaces/toast.ids.interface';
import { formatCreatedAt } from '../../../../services/helpers';
import { ENUM_ROLES, ENUM_PERMISSIONS } from '../../../../interaces/enums/enums.interface';
import { updateDataWhenUpdate, updateDataWhenDelete } from '../../../../services/helpers';
import { useRoles } from '../../../roles/hooks/useRoles';
import { useAuth } from '../../../../context/AuthContext';
import { ENUM_INVITATIONS_STATUS } from '../../interfaces/invitations.interface';
function UsersManagement() {
  const [openModal, setOpenModal] = useState(false);
  const [openModalInvitation, setOpenModalInvitation] = useState(false);
  const [openInviteModal, setOpenInviteModal] = useState(false);
  const { hasPrivilege } = useAuth();
  const [activeTab, setActiveTab] = useState(
    hasPrivilege(ENUM_PERMISSIONS.MOD_USERS_MANAGEMENT_READ)
      ? TABS_USERS_ENUM.USERS
      : TABS_USERS_ENUM.INVITATIONS
  );
  //DataTable
  const [showConfirmationCancelInvitation, setShowConfirmationCancelInvitation] = useState(false);
  const [confirmUser, setConfirmUser] = useState(false);
  const [invitationToCancel, setInvitationToCancel] = useState(null);
  const [modeInvitation, setModeInvitation] = useState(MODE.CREATE);
  const [modelInvitation, setModelInvitation] = useState();
  const [mode, setMode] = useState(MODE.CREATE);
  const [model, setModel] = useState();
  const {
    entities,
    setEntities,
    fetchSearch,
    loading,
    searchValue,
    setSearchValue,
    onClear,
    dataPagination,
    setPageData,
    pageData,
    dataFilters,
    setDataFilters,
    setNames,
  } = useUsers();
  const {
    entities: entitiesInvitations,
    setEntities: setEntitiesInvitations,
    fetchSearch: fetchInvitations,
    loading: loadingInvitations,
    searchValue: searchValueInvitations,
    setSearchValue: setSearchValueInvitations,
    onClear: onClearInvitations,
    dataPagination: dataPaginationInvitations,
    setPageData: setPageDataInvitations,
    pageData: pageDataInvitations,
    dataFilters: dataFiltersInvitations,
    setDataFilters: setDataFiltersInvitations,
    setNames: setNamesRoles,
  } = useInvitations();
  //ROLES
  const { names: namesRoles, getNames: getNamesRoles } = useRoles();
  useEffect(() => {
    getNamesRoles();
  }, []);
  useEffect(() => {
    if (namesRoles) {
      setNames(namesRoles);
      setNamesRoles(namesRoles);
    }
  }, [namesRoles]);
  useEffect(() => {
    if (!namesRoles) return;
    if (activeTab == TABS_USERS_ENUM.USERS) fetchSearch();
    if (activeTab == TABS_USERS_ENUM.INVITATIONS) fetchInvitations();
  }, [activeTab, namesRoles]);
  const handleEdit = (entity) => {
    setMode(MODE.UPDATE);
    setModel(entity);
    setOpenModal(true);
  };
  const handleEditInvitation = (entity) => {
    setModeInvitation(MODE.UPDATE);
    setModelInvitation(entity);
    setOpenModalInvitation(true);
  };
  const handleDelete = async () => {
    try {
      await usersApi.remove(model.id);
      setModel(null);
      updateDataWhenDelete(setEntities, model.id);
      toast.success(TOAST_SUCCESS_IDS.RECORD_DELETED_SUCCESSFULLY, {
        id: TOAST_SUCCESS_IDS.RECORD_DELETED_SUCCESSFULLY,
      });
      setConfirmUser(false);
    } catch (error) {
      toast.error(error.message || 'Error al eliminar el usuario.');
    }
  };
  const handleActivate = async (id) => {
    try {
      const response = await usersApi.activate(id);
      updateDataWhenUpdate(setEntities, response);

      toast.success('Usuario activado exitosamente.');
    } catch (error) {
      toast.error(error.message || 'Error al activar el usuario.');
    }
  };

  const handleDeactivate = async (id) => {
    try {
      const response = await usersApi.deactivate(id);
      updateDataWhenUpdate(setEntities, response);
      toast.success('Usuario desactivado exitosamente.');
    } catch (error) {
      toast.error(error.message || 'Error al desactivar el usuario.');
    }
  };

  const handleCancelInvitation = async () => {
    try {
      const response = await usersApi.cancelInvitation(invitationToCancel.id);
      toast.success(TOAST_INFO_IDS.INVITATION_SUCCESSFULLY_CANCELLED, {
        id: TOAST_INFO_IDS.INVITATION_SUCCESSFULLY_CANCELLED,
      });
      updateDataWhenUpdate(setEntitiesInvitations, response);
      setShowConfirmationCancelInvitation(false);
    } catch (error) {
      toast.error(error.message || TOAST_ERROR_IDS.ERROR_CANCELING_INVITATION);
    }
  };
  const columns = [
    {
      accessorKey: 'username',
      header: 'USUARIO',
    },
    {
      accessorKey: 'name',
      header: 'NOMBRE',
    },
    {
      accessorKey: 'firstLastName',
      header: 'PRIMER APELLIDO',
    },
    {
      accessorKey: 'secondLastName',
      header: 'SEGUNDO APELLIDO',
    },

    {
      accessorKey: 'email',
      header: 'CORREO',
    },
    {
      accessorKey: 'role',
      header: 'ROL',
    },
    {
      accessorKey: 'estatus',
      header: 'ESTADO',
      cell: ({ row }) => {
        const status = row.original.status;
        return (
          <span
            className={`
          status-register
          ${status ? 'status-color-active' : 'status-color-inactive'}
        `}
          >
            {status ? 'Activo' : 'Inactivo'}
          </span>
        );
      },
    },
    ...(hasPrivilege(ENUM_PERMISSIONS.MOD_USERS_MANAGEMENT_UPDATE) ||
    hasPrivilege(ENUM_PERMISSIONS.MOD_USERS_MANAGEMENT_DELETE)
      ? [
          {
            id: 'acciones',
            header: 'ACCIONES',
            cell: ({ row }) => {
              const item = row.original;
              return (
                <div className="div-actions">
                  <ActionsTable
                    canDelete={item.role != ENUM_ROLES.SUPERADMIN}
                    handleEdit={() => {
                      handleEdit(item);
                    }}
                    handleDelete={() => {
                      setModel(item);
                      setConfirmUser(true);
                    }}
                    tienePermisoEditar={hasPrivilege(ENUM_PERMISSIONS.MOD_USERS_MANAGEMENT_UPDATE)}
                    tienePermisoEliminar={hasPrivilege(
                      ENUM_PERMISSIONS.MOD_USERS_MANAGEMENT_DELETE
                    )}
                  />
                  {item.status ? (
                    <button
                      className="btn-action-delete"
                      title="Desactivar"
                      onClick={() => handleDeactivate(item.id)}
                    >
                      <FaTimesCircle className="icon-btn-action-delete" />
                    </button>
                  ) : (
                    <button
                      className="btn-action-success"
                      title="Activar"
                      onClick={() => handleActivate(item.id)}
                    >
                      <FaCheckCircle className="iconFaCheckCircle" />
                    </button>
                  )}
                </div>
              );
            },
          },
        ]
      : []),
  ];
  //COLUMNS PARA INVITACIONES
  const columnsInvitations = [
    {
      accessorKey: 'email',
      header: 'CORREO',
    },
    {
      accessorKey: 'roleToGrant',
      header: 'ROL A OTORGAR',
    },
    {
      accessorKey: 'createdAt',
      header: 'FECHA Y HORA DE ENVÍO',
      cell: ({ row }) => {
        const item = row.original;
        return <span>{formatCreatedAt(item.createdAt)}</span>;
      },
    },
    {
      accessorKey: 'status',
      header: 'ESTADO',
      cell: ({ row }) => {
        const status = row.original.status;
        return (
          <span
            className={`
     status-register
    ${status == 'PENDING' ? 'status-color-active' : 'status-color-inactive'}
  `}
          >
            {status}
          </span>
        );
      },
    },
    ...(hasPrivilege(ENUM_PERMISSIONS.MOD_USERS_INVITATIONS_UPDATE) ||
    hasPrivilege(ENUM_PERMISSIONS.MOD_USERS_INVITATIONS_DELETE)
      ? [
          {
            id: 'acciones',
            header: 'ACCIONES',
            cell: ({ row }) => {
              const item = row.original;
              const canEdit = hasPrivilege(ENUM_PERMISSIONS.MOD_USERS_INVITATIONS_UPDATE);
              return (
                <div className="div-actions">
                  <ActionsTable
                    canDelete={false}
                    handleEdit={() => {
                      handleEditInvitation(item);
                    }}
                    tienePermisoEditar={canEdit}
                    tienePermisoEliminar={hasPrivilege(
                      ENUM_PERMISSIONS.MOD_USERS_INVITATIONS_DELETE
                    )}
                  />
                  {canEdit && item.status == ENUM_INVITATIONS_STATUS.PENDING && (
                    <button
                      className="btn-action-ActionsTable "
                      title="Cancelar Invitación"
                      onClick={() => {
                        setShowConfirmationCancelInvitation(true);
                        setInvitationToCancel(item);
                      }}
                    >
                      <FaTimesCircle className="icon-btn-FaSlidersH" />
                    </button>
                  )}
                </div>
              );
            },
          },
        ]
      : []),
  ];
  //
  return (
    <DashboardLayout>
      <div className="page-container">
        <div className="page-header-row">
          <div className="page-title-wrapper">
            <p className="page-subtitle">Administración de usuarios del sistema.</p>
          </div>
        </div>
        <div className="tabs-bar">
          {TABS_USERS.map(
            (tab) =>
              hasPrivilege(tab.permission) && (
                <button
                  key={tab.id}
                  type="button"
                  onClick={() => setActiveTab(tab.id)}
                  className={`tab-item ${activeTab === tab.id ? 'tab-item-active' : ''}`}
                >
                  {tab.icon} {tab.id}
                </button>
              )
          )}
        </div>
        {activeTab == TABS_USERS_ENUM.USERS && (
          <DataTable
            columns={columns}
            data={entities}
            searchPlaceholder="Buscar usuario por nombre,apellido o correo..."
            pageSize={4}
            loading={loading}
            emptyMessage="No hay registros"
            showSearch={true}
            showPagination={true}
            onSearch={() => fetchSearch()}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            showCreate={hasPrivilege(ENUM_PERMISSIONS.MOD_USERS_MANAGEMENT_CREATE)}
            setOpenModal={setOpenModal}
            onClear={() => onClear()}
            showFilters={true}
            dataFilters={dataFilters}
            setDataFilters={setDataFilters}
            numberFilters={2}
            setMode={setMode}
            setModel={setModel}
            dataPagination={dataPagination}
            setPageData={setPageData}
            pageData={pageData}
          />
        )}
        {activeTab == TABS_USERS_ENUM.INVITATIONS && (
          <DataTable
            columns={columnsInvitations}
            data={entitiesInvitations}
            searchPlaceholder="Buscar registro por correo..."
            pageSize={4}
            loading={loadingInvitations}
            emptyMessage="No hay registros"
            onRowClick={(data) => {}}
            showSearch={true}
            showPagination={true}
            onSearch={() => fetchInvitations()}
            searchValue={searchValueInvitations}
            setSearchValue={setSearchValueInvitations}
            showCreate={hasPrivilege(ENUM_PERMISSIONS.MOD_USERS_INVITATIONS_CREATE)}
            setOpenModal={setOpenModalInvitation}
            onClear={() => onClearInvitations()}
            setMode={setModeInvitation}
            showFilters={true}
            dataFilters={dataFiltersInvitations}
            setDataFilters={setDataFiltersInvitations}
            numberFilters={2}
            setModel={setModelInvitation}
            dataPagination={dataPaginationInvitations}
            setPageData={setPageDataInvitations}
            pageData={pageDataInvitations}
          />
        )}
        {openModal && (
          <ModalUsers
            setEntities={setEntities}
            onClose={() => setOpenModal(false)}
            mode={mode}
            model={model}
          />
        )}
        {openModalInvitation && (
          <ModalInvitacions
            open={openInviteModal}
            onClose={() => setOpenModalInvitation(false)}
            mode={modeInvitation}
            model={modelInvitation}
            setEntities={setEntitiesInvitations}
          />
        )}
        {showConfirmationCancelInvitation && (
          <ConfirmationMessage
            message={TOAST_INFO_IDS.ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_INVITATION}
            onConfirm={handleCancelInvitation}
            onCancel={() => {
              setShowConfirmationCancelInvitation(false);
            }}
          />
        )}
        {confirmUser && (
          <ConfirmationMessage
            message={TOAST_INFO_IDS.ARE_YOU_SURE_WANT_TO_DELETE_THIS_RECORD}
            onConfirm={handleDelete}
            onCancel={() => {
              setConfirmUser(false);
            }}
          />
        )}
      </div>
    </DashboardLayout>
  );
}

export default UsersManagement;
